import axios from "axios";

const baseurl = axios.create({
  baseURL: "https://portal.edentransport.co.ke/backend/public/",
  timeout: 100000,
  headers: {
    "content-Type": "application/json"
  }
});
baseurl.interceptors.request.use(
  function(config) {
    const token = localStorage.getItem("id_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export default baseurl;



// WEBPACK FOOTER //
// ./src/configurations/baseurl/baseurl.js